export default "__VITE_ASSET__88f12e3c__"